
<template>
    <WCard class="TheLogin">
        <form
            class="Form pt-1"
            @submit.prevent="handleSubmit"
        >
            <div class="Form_Field">
                <WText
                    tag="label"
                    typo="label"
                    :size="14"
                >
                    {{ $t('auth.signin.username.label') }}
                </WText>
                <WFieldError
                    :validator="$v.username"
                    :label="$t('auth.signin.username.label')"
                    #default="{ errorMessage, listeners }"
                >
                    <WInput
                        v-model="username"
                        :error="errorMessage"
                        type="text"
                        :placeholder="$t('auth.signin.username.placeholder')"
                        name="username"
                        v-on="listeners"
                    />
                </WFieldError>
            </div>
            <div class="Form_Field">
                <WText
                    tag="label"
                    typo="label"
                    :size="14"
                >
                    {{ $t('auth.signin.password.label') }}
                </WText>
                <WFieldError
                    :validator="$v.password"
                    :label="$t('auth.signin.password.label')"
                    #default="{ errorMessage, listeners }"
                >
                    <WInput
                        v-model="password"
                        :error="errorMessage"
                        type="password"
                        :placeholder="$t('auth.signin.password.placeholder')"
                        name="password"
                        v-on="listeners"
                    />
                </WFieldError>
            </div>
            <div class="flex row-right-center mt-2">
                <WButton
                    v-if="forceLogin"
                    data-cy="forceLoginBtn"
                    color="link"
                    linkColor="secondary"
                    @click="handleForceLogin"
                >
                    {{ $t('auth.signin.forceLoginBtn') }}
                </WButton>
                <WButton
                    :loading="disabled"
                    :disabled="disabled"
                    data-cy="loginBtn"
                    class="flex row-center pl-2 pr-2"
                    @click="handleSubmit"
                >
                    {{ $t('auth.signin.signinBtn') }}
                </WButton>
            </div>
        </form>
    </WCard>
</template>

<script>
import VueTypes from 'vue-types'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
    name: 'TheLogin',
    mixins: [validationMixin],
    props: {
        devLogin: VueTypes.shape({
            user: VueTypes.string,
            pass: VueTypes.string,
        }).def({}),
        forceLogin: VueTypes.bool.def(false),
        disabled: VueTypes.bool.def(false),
    },
    data () {
        const { user, pass } = this.devLogin || {}
        return { username: user || '', password: pass || '' }
    },
    validations () {
        return {
            username: { required },
            password: { required, minLength: minLength(6), maxLength: maxLength(20) },
        }
    },
    methods: {
        handleSubmit () {
            if (!this.$v.$invalid) {
                this.$emit('onLogin', {
                    username: this.username,
                    password: this.password,
                })
            }
        },
        handleForceLogin () {
            this.$emit('onForceLogin')
        },
    },
}
</script>

<style scoped lang="scss">
.TheLogin {
    width: 95%;
    max-width: 400px;
    padding: 15px;

    .Form {
        position: relative;

        &_Field + .Form_Field {
            margin-top: 25px;
        }

        .Form_ForceLogin {
            position: absolute;
            bottom: -40px;
            width: 100%;
        }
    }
}

</style>
